/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";

const Blogs = () => {
  const [Blog, setBlog] = useState([]);
  const [searchBlog, setSearchBlog] = useState("");

  useEffect(() => {
    fetch("https://automate.devssh.xyz/api/blogs")
      .then((response) => response.json())
      .then((data) => {
        setBlog(data.data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, []);

  const filterBlog = Blog.filter((item) =>
    item.title.toLowerCase().includes(searchBlog.toLowerCase())
  );

  const blogToDisplay = searchBlog.trim() === "" ? Blog : filterBlog;

  return (
    <>
      <div className="blog-search">
        <div className="search-box">
          <form className="form">
            <label htmlFor="search">
              <input
                className="input"
                name="search"
                type="text"
                required
                placeholder="Search Blogs"
                id="search"
                value={searchBlog}
                onChange={(e) => setSearchBlog(e.target.value)}
              />
              <div className="fancy-bg" />
              <div className="search"></div>
            </label>
          </form>
        </div>
      </div>

      <div className="wrapper">
        {blogToDisplay.length === 0 ? (
          <div className="Blog-Default">
            <h1>No blogs found</h1>
          </div>
        ) : (
          blogToDisplay.map((item, index) => (
            <div className="card" key={index}>
              <div className="card-banner">
                <img className="banner-img" src={item.image} alt="" />
              </div>
              <div className="card-bode">
                <h3 className="blog-title">{item.title}</h3>
                <p className="blog-description">
                  <div dangerouslySetInnerHTML={{ __html: item.description }} />
                </p>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default Blogs;
